function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.907 15.847V.463a.5.5 0 1 0-1 0v15.384a.5.5 0 1 0 1 0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.407 1.263l3.314 4.142a.5.5 0 1 0 .78-.625L8.799.15a.5.5 0 0 0-.781 0L4.313 4.78a.5.5 0 1 0 .781.625l3.313-4.142zM6.093 9.222H2.998A2.504 2.504 0 0 0 .5 11.72V22.54a2.504 2.504 0 0 0 2.498 2.498h10.819a2.504 2.504 0 0 0 2.498-2.498V11.72a2.493 2.493 0 0 0-2.498-2.498h-3.095a.5.5 0 1 0 0 1h3.095c.832 0 1.498.668 1.498 1.498V22.54c0 .821-.675 1.498-1.498 1.498H2.998A1.504 1.504 0 0 1 1.5 22.539V11.72c0-.821.675-1.498 1.498-1.498h3.095a.5.5 0 1 0 0-1z"
});

var SvgShareIcon = function SvgShareIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 26,
    viewBox: "0 0 17 26",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color,
    fillRule: "nonzero"
  }, _ref2, _ref3));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share_icon.a5cdacec.svg";
export { ForwardRef as ReactComponent };